module.exports = __webpack_public_path__ + "static/placeholder-1-122d1c5ab782f133bf71d5d8863a0982.jpg";